import { render, staticRenderFns } from "./termosDeUso.vue?vue&type=template&id=2ed8a245&"
import script from "./termosDeUso.vue?vue&type=script&lang=js&"
export * from "./termosDeUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports